import React, { useState } from 'react';
import UrlConfig from '../../data/UrlConfig'; // Ajusta la ruta a tu archivo UrlConfig.js

const API_URLS = UrlConfig; // Llama a la función para obtener las URLs completas

const NewsletterSubscribe = () => {
    const [email, setEmail] = useState('');
    const [nick, setNick] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');
        setError('');

        try {
            // ¡Usamos la URL del archivo de configuración!
            const response = await fetch(API_URLS.leads_add, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email,
                    nick,
                    page: 'Newsletter Archive',
                    section: 'Subscription Form',
                    status: 'Subscribed via Form'
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(data.message); // Mostramos el mensaje dinámico del backend
                setEmail('');
                setNick('');
            } else {
                throw new Error(data.message || 'Ocurrió un error al procesar tu solicitud.');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    // ... el resto de tu JSX del return no necesita cambios ...
    return (
        <div className="bg-gray-800 p-8 rounded-lg mt-12">
            <h3 className="text-2xl font-bold text-white mb-4">Únete a la Comunidad</h3>
            <p className="text-gray-400 mb-6">Recibe análisis y contenido exclusivo directamente en tu bandeja de entrada.</p>
            <form onSubmit={handleSubmit}>
                <div className="flex flex-col md:flex-row gap-4">
                    <input
                        type="text"
                        value={nick}
                        onChange={(e) => setNick(e.target.value)}
                        placeholder="Tu nombre o apodo"
                        className="flex-grow p-3 bg-gray-700 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-400"
                        required
                    />
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Tu correo electrónico"
                        className="flex-grow p-3 bg-gray-700 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-400"
                        required
                    />
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="bg-emerald-500 text-white font-bold py-3 px-6 rounded-md hover:bg-emerald-600 transition-colors disabled:bg-gray-500"
                    >
                        {isLoading ? 'Procesando...' : 'Unirme'}
                    </button>
                </div>
                {message && <p className="text-green-400 mt-4">{message}</p>}
                {error && <p className="text-red-400 mt-4">{error}</p>}
            </form>
        </div>
    );
};

export default NewsletterSubscribe;